<template>
  <div class="news-list">
    <ul>
      <li
        v-for="(item, index) of newsList"
        :key="index"
        @click="goArticle(item.id)"
        class="flex-box"
      >
        <div class="title">{{ item.title }}</div>
        <div>
          <span>发布人: {{ item.publisher }}</span>
          <span>{{ item.date | date }}</span>
        </div>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>
<script>
import timeStamp from '@/utils/timeStamp'

export default {
  props: [
    'newsList'
  ],
  data () {
    return {}
  },
  methods: {
    goArticle (id) {
      this.$router.push({
        path: this.$route.path + '#article',
        query: {
          arId: id,
          navId: this.$route.meta.id
        }
      })
    }
  },
  filters: {
    date (value) {
      return timeStamp(value)
    }
  }
}
</script>
<style lang="scss" scoped>
.news-list {
  font-size: 0.12rem;
  ul {
    li {
      margin: 0.1rem;
      .title {
        width: 490px;
      }
      &::before {
        content: "";
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        background: $color-blue;
        border-radius: 50%;
      }
      &:hover {
        color: $color-blue;
        cursor: pointer;
      }
    }
  }
}
</style>